import '../scss/components/scroll-to-top.scss';

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

window.addEventListener('scroll', () => {
    const scrollHeight = window.scrollY;
    if (scrollHeight >= window.innerHeight) {
        document.querySelector('.scroll-to-top').classList.add('show');
    } else {
        document.querySelector('.scroll-to-top').classList.remove('show');
    }
});
document.querySelector('.scroll-to-top').addEventListener('click', scrollToTop);